export default __webpack_public_path__ + "images/background-circle.d87b3555c3fcf376962e53ae30c0a517.png";